import React from "react";

export default function H4(props) {
  return (
    <h1 className="text-lg lg:text-xl font-medium text-secondary py-2">
      {props.children}
    </h1>
  );
}
